export default __webpack_public_path__ + "static/media/031-caravan.54d00ee9.svg";